var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.55 24.85l-7.1-7.05c1.6-1.85 2.5-4.2 2.5-6.8 0-5.7-4.7-10.4-10.4-10.4C4.8.6.2 5.3.2 11c0 5.75 4.65 10.4 10.35 10.4 2.55 0 4.9-.9 6.75-2.5l7.05 7.1c.2.15.4.2.65.2.2 0 .4-.05.55-.2.3-.3.3-.85 0-1.15zM10.6 19.8c-4.9 0-8.8-3.95-8.8-8.8 0-4.85 3.9-8.8 8.8-8.8 4.85 0 8.8 3.95 8.8 8.8 0 4.9-3.95 8.8-8.8 8.8z",
    fill: "currentColor"
  })));
}
export default SvgMagnifyingGlassIcon;